import { AppShell, Burger, Group, Image } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import DoubleNavbar from './DoubleNavbar';

export default function AviaryShell({ children }) {
  const [opened, { toggle, close }] = useDisclosure();
  const isDesktop = useMediaQuery('(min-width: 768px)', true);

  return (
    <AppShell
      header={{ height: 56, collapsed: !!isDesktop }}
      navbar={{ width: 80, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding={0}
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between" bg="aviary.8">
          <Burger opened={opened} onClick={toggle} size="sm" color="#EBE2D3" />
          <Image src="/logo_small.png" h={36} fit="contain" />
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p={0} style={{ overflow: 'hidden' }}>
        <DoubleNavbar onNavClick={close} />
      </AppShell.Navbar>

      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
